import 'antd/dist/antd.variable.less';
import './global.less';
import '../dayjs.extend';
import './initializeSentry';
